import { useMemo, useState } from 'react';
import { Image } from 'antd';
import { ImagePreviewCompare } from '@/components/ImagePreviewCompare';
import EmptyBox from '../EmptyBox';

import cx from './index.module.scss';

interface Props {
  questionnaireAnswer: GetActionTestQuestionnaireResponse;
}

function areAllValuesEmpty(arr) {
  return arr?.every(item => !item.value);
}

const ShockwaveEffectRecord: React.FC<Props> = ({ questionnaireAnswer }) => {
  const [previewIndex, setPreviewIndex] = useState<number>(0);

  const beforeHandImg = useMemo(
    () => questionnaireAnswer?.beforehand?.map(item => item && JSON.parse(item)),
    [questionnaireAnswer]
  );
  const afterWardsImg = useMemo(
    () => questionnaireAnswer?.afterwards?.map(item => item && JSON.parse(item)),
    [questionnaireAnswer]
  );

  const questionnaire = useMemo(() => {
    let parsedData = null;
    try {
      parsedData = JSON.parse(questionnaireAnswer?.questionnaire);
    } catch {
      parsedData = null;
    }
    return parsedData;
  }, [questionnaireAnswer]);

  return (
    <div className={cx('wrapper')}>
      {(beforeHandImg?.length === 0 && afterWardsImg?.length === 0) ||
      (areAllValuesEmpty(beforeHandImg) && areAllValuesEmpty(afterWardsImg)) ? (
        <EmptyBox />
      ) : (
        <div className={cx('content-wrapper')}>
          <ImagePreviewCompare
            beforeImgList={beforeHandImg?.map(item => item?.value) || []}
            afterImgList={afterWardsImg?.map(item => item?.value) || []}
            previewIndex={previewIndex}
            source="no-servicing"
            noAfterUploadText="服务后动作测试未上传"
            updatePreviewIndex={setPreviewIndex}
            totalCompareLength={questionnaire?.action_test?.length}
          >
            {questionnaire?.action_test?.map((item, index) => {
              return (
                <div key={item.title} className={cx('item')}>
                  <div className={cx('box', { 'empty-data': !beforeHandImg?.[index]?.value })}>
                    {beforeHandImg?.[index]?.value ? (
                      <>
                        <Image
                          onClick={() => setPreviewIndex(index)}
                          preview={{ maxScale: 5 }}
                          className={cx('img')}
                          alt="motion-item"
                          src={beforeHandImg?.[index]?.value}
                        />

                        <div className={cx('tag', 'before')}>服务前</div>
                      </>
                    ) : (
                      <>
                        <div className={cx('empty-text')}>服务前</div>
                        <div className={cx('empty-text', 'bottom-text')}>动作测试图片未上传</div>
                      </>
                    )}
                  </div>
                  <div className={cx('box', { 'empty-data': !afterWardsImg?.[index]?.value })}>
                    {afterWardsImg?.[index]?.value ? (
                      <>
                        <Image
                          onClick={() => setPreviewIndex(index)}
                          preview={{ maxScale: 5 }}
                          className={cx('img')}
                          alt="motion-item"
                          src={afterWardsImg?.[index]?.value}
                        />

                        <div className={cx('tag', 'after')}>服务后</div>
                      </>
                    ) : (
                      <>
                        <div className={cx('empty-text')}>服务后</div>
                        <div className={cx('empty-text', 'bottom-text')}>动作测试图片未上传</div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </ImagePreviewCompare>
        </div>
      )}
    </div>
  );
};

export default ShockwaveEffectRecord;
